import { FormEvent, useEffect, useState } from "react";
import { VideoVisibilityForm } from "./components/VideoVisibilityForm";
import { DownArrowIcon, TrashIcon } from "assets";
import { ApiError, CustomTooltip, SmallScreenModel } from "components";
import { updateVideoVisibility } from "../store/action";
import { UpdateSingleDataInput, VideoDetailProps } from "../store/actionType";
import { connect, useSelector } from "react-redux";

interface OwbProps {
  videoData: VideoDetailProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwbProps;
const UpdateVideoVisibility: React.FC<Props> = ({
  onUpdateVisibility,
  videoData,
}) => {
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );
  const [openModel, setOpenModel] = useState(false);
  const [visibility, setVisibility] = useState(videoData?.visibility);
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { value } = e.target;
    setVisibility(value);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    const input: UpdateSingleDataInput = {
      field: "visibility",
      value: visibility,
      video_id: videoData.id.toString(),
    };
    onUpdateVisibility(input);
  };
  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error); 
      } else if (videoDetailsState.status === "SUCCESS") {
        setApiError(null);
        setOpenModel(false);
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);
  return (
    <>
      <CustomTooltip title="update Video Visibility" placement="right">
        <button onClick={() => setOpenModel(true)}>
          <DownArrowIcon className="size-4 mr-2 text-gray-600 hover:text-black" />
        </button>
      </CustomTooltip>
      <SmallScreenModel setShowModal={setOpenModel} showModal={openModel}>
        <VideoVisibilityForm
          loading={false}
          visibility={visibility}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
        {apiError && <ApiError>{apiError}</ApiError>}
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateVisibility: (input: UpdateSingleDataInput) =>
    dispatch(updateVideoVisibility(input)),
});

export default connect(null, mapDispatchToProps)(UpdateVideoVisibility);
